import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player";

const defaultEmpVideoSrc = "/empImg/Black_img.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: 500,
  width: 800,
  // bgcolor: 'background.paper',
  bgcolor: "#ffab91",
  // border: '1px solid #59b9ea',
  borderColor: "primary.light",
  boxShadow: 24,
  p: 3,
};

function VideoMath() {
  const [startPlay, setStartPlay] = useState(false);
  //const [starPush, setStartPush] = useState(true);
  //히스토리사용
  const history = useHistory();
  const ref = useRef(null);

  const startPlayHandle = () => {
    ref.current.showPreview();
    setStartPlay(true);
  };

  useEffect(() => {
    startPlayHandle();
  }, [startPlay]);

  return (
    <div>
      <div style={style}>
        <ReactPlayer
          light={defaultEmpVideoSrc}
          poster={defaultEmpVideoSrc} // 플레이어 초기 포스터 사진
          url={process.env.PUBLIC_URL + "mathVideos/math.mp4"}
          width="100%"
          height="100%"
          controls={true}
          muted={false} //음소거
          playing={startPlay} //자동재생
          onReady={() => setStartPlay(true)} // 영상이 로드되어 준비된 상태
          ref={ref}
          config={{
            file: {
              attributes: {
                controlsList: "nodownload",
              },
            },
          }}
        />
        <div style={{ textAlign: "center" }}>
          <h2>대안수학 이야기</h2>
        </div>
        <Button
          variant="contained"
          style={{
            background: "#0277bd",
            color: "white",
            height: "37px",
            width: 120,
            marginRight: "2px",
            float: "center",
          }}
          onClick={() => {
            history.push("/");
          }}
        >
          서브이동
        </Button>
      </div>
    </div>
  );
}

export default VideoMath;
